import React from "react";
import { Button } from "../../../Shared/Buttons/Button";
import { BannerTitle } from "../../../Shared/Headings/BannerTitle";
import { browser } from "@workspace/mobile";
import comingSoonImage from "../../../../assets/placeholders/coming-soon.png";

export const ComingSoon = () => {
  return (
    <div className="ComingSoon bg-[var(--diaryGridSolid)] h-full w-full flex flex-col justify-center items-center">
      <img width="280" src={comingSoonImage} alt="Coming Soon" />
      <div className="pt-6">
        <BannerTitle title="Coming Soon" />
      </div>
      <p className="text-[15px] pb-3">Any questions?</p>
      <div className="w-40">
        <Button
          fill={"outline"}
          className="ComingSoonContactButton h-10"
          expand={true}
          size={"lg"}
          onClick={() => {
            browser.open(
              "https://access-support.force.com/Support/s/login/",
              "external"
            );
          }}
        >
          Contact Us
        </Button>
      </div>
    </div>
  );
};
